import { Span } from 'themes/jumbo/@jumbo/shared';
import {
  Avatar,
  Chip,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { ViewType } from './types';
import { getCachedData } from "api/Cache";
import { useHistory } from 'react-router-dom';
import { formatDate } from "services/UtilsService";


const ViewItem = ({ item }: {item:ViewType}) => {
  const { ID:viewID, name:viewName = 'Unknown View', project = '', thumb = '', state = 'pending', file_date:creationDate = '' } = item;
  const projects: any = getCachedData("projects");
  const projectName = projects[project] ? projects[project].name : "Unknown Project";
  const history = useHistory();
  const handleClick = (e: any) => {
      history.push(`/views/${viewID}`);
  };
  const stateColor: any = {
    complete: '#5AADE3',
    error: '#CC0000',
    pending: '#EDA135'
  }

  return (
    <ListItemButton
      component={'li'}
      sx={{
        //p: (theme) => theme.spacing(1.25, 3),
        p: '8px 24px',
        transition: 'all 0.2s',

        '&:hover': {
          //boxShadow: `rgba(0, 0, 0, 0.2) 0px 3px 2px 0px`,
          //transform: 'translateY(-4px)',
        },
      }}
      onClick={handleClick}
    >
      <ListItemAvatar sx={{ 
        minWidth: {xs: 65, sm:65, md:85, lg:85, xl:85}, 
        mr: 2, 
        overflow: 'hidden', 
        borderRadius: 2 
      }}>
        <img
          alt={viewName}
          src={thumb}
          width={"100%"}
          height={"auto"}
          style={{ verticalAlign: 'middle', maxWidth: '85px' }}
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography variant={'h5'} mb={0.5} className='listItemTitle'>
            {viewName}
          </Typography>
        }
        secondary={
          <Typography variant={'h6'} mb={0.5} color={'text.secondary'} style={{fontSize: '12px'}}>
            {projectName}
          </Typography>
        }
        sx={{ width:'50%' }}
      />
      <ListItemText
        primary={
          <Typography variant={'h6'} color={'text.secondary'} style={{fontSize: '13px'}}>
            {creationDate ? formatDate(creationDate) : "---"}
          </Typography>
        }
        sx={{display: {xs: 'none', sm:'none', md:'flex', lg:'flex', xl:'flex'}}}
      />
      <Chip
        size={'small'}
        label={state}
        sx={{
          width: 'auto',
          textAlign: 'center',
          transform: 'scale(.8)',
          display: {xs: 'none', sm:'none', md:'flex', lg:'flex', xl:'flex'},
          bgcolor: stateColor[state?.toLowerCase()] || 'warning',
          color: '#fff'
        }}
      />
    </ListItemButton>
  );
};

export { ViewItem };
